export const form = {
    note: '',
    user: null,
}
  